// La nouvelle interface, épurée (9 octobre 2026) : le weekly. Les textes que
// l'écran classique avait déjà (titre, natures, relecture) restent lus dans
// `projector.weekly`.
export default {
  semaine: 'Semaine du {jour}',
  luLe: 'lu le {moment}',
  filtre: 'Filtrer les idées par nature',
  tout: 'Tout',
  natures: {
    espace_blanc: 'Espaces blancs',
    emergence: 'Émergences',
    opportunite: 'Opportunités',
    extension: 'Extensions',
  },
  force: {
    forte: 'signal fort',
    moyenne: 'signal moyen',
    faible: 'signal faible',
  },
  pourquoiMaintenant: 'Pourquoi maintenant.',
  lireLaSuite: 'Lire la suite',
  reduire: 'Réduire',
  signaux: 'Les signaux :',
  aTrancher: 'À trancher :',
  poserLaQuestion: 'Poser la question',
  approfondir: 'Approfondir',
  videTexte: 'Le weekly se lit de lui-même chaque semaine. « Lire la semaine » le lance tout de suite.',
}
